import { pageClick, wasItHelpfulView } from '@wix/bi-logger-customer-care-data/v2';
import { HEADER_AUTH_CLICKED_ITEM_IDS } from '@wix/cc-user-facing-common-components';
import { useRouter } from 'next/router';

import { BI } from '../../constants';
import { useBI } from '../../hooks/useBI';
import { mapPageTypeToSourceName } from '../../utils/bi';
import { useStore } from '../../zustand/stores';

const getClickedItemType = (clickedItemId?: string): string => {
  switch (clickedItemId) {
    case HEADER_AUTH_CLICKED_ITEM_IDS.LOG_IN:
    case HEADER_AUTH_CLICKED_ITEM_IDS.GET_STARTED:
    case HEADER_AUTH_CLICKED_ITEM_IDS.CANT_LOG_IN:
      return clickedItemId;
    default:
      return BI.CLICKED_ITEM_TYPES.HEADER_CLICK;
  }
};

export const useHeaderBI = () => {
  const { sendBIEvent } = useBI();
  const { locale } = useRouter();
  const itemId = useStore((state) => state.pageSlice.itemId);
  const { selfServiceSessionId } = useStore((state) => state.sessionSlice.sessionBI);
  const pageType = useStore((state) => state.pageSlice.pageType);

  const onLinkClick = async (clickedText: string, clickedUrl: string, clickedItemId?: string) => {
    await sendBIEvent(
      pageClick({
        self_service_session_id: selfServiceSessionId ?? undefined,
        source_name: mapPageTypeToSourceName(pageType),
        kb_lang: locale,
        item_id: itemId,
        clicked_item_type: getClickedItemType(clickedItemId),
        clicked_text: clickedText,
        clicked_url: clickedUrl,
        clicked_item_id: clickedItemId,
      })
    );
  };

  const onItemView = async (itemName: string) => {
    await sendBIEvent(
      wasItHelpfulView({
        self_service_session_id: selfServiceSessionId ?? undefined,
        source_name: mapPageTypeToSourceName(pageType),
        kb_lang: locale,
        item_name: itemName,
      }));
  };

  return { onLinkClick, onItemView };
};
